const rulesAcceptedKey = (leagueId: number): string => `dp_rules_accepted_${leagueId}`;

export function hasAcceptedLeagueRules(leagueId: number): boolean {
  try {
    return localStorage.getItem(rulesAcceptedKey(leagueId)) === 'true';
  } catch {
    return false;
  }
}

export function acceptLeagueRules(leagueId: number): void {
  try {
    localStorage.setItem(rulesAcceptedKey(leagueId), 'true');
  } catch {
    // Le parcours reste utilisable si le stockage local est indisponible.
  }
}

export function clearLeagueRulesAcceptance(leagueId: number): void {
  try {
    localStorage.removeItem(rulesAcceptedKey(leagueId));
  } catch {
    // Le nettoyage local ne doit pas bloquer la finalisation du club.
  }
}
